// Tap-to-toggle chips of published checklists.
export const ChecklistPicker = ({ options, value, onChange, testid = "checklist-picker" }) => {
  if (!options.length) return <p className="text-sm text-slate-400" data-testid={`${testid}-empty`}>No published checklists yet. Create one in Forms & Checklists.</p>;
  return (
    <div className="flex flex-wrap gap-2" data-testid={testid}>
      {options.map((o) => {
        const on = value.includes(o.id);
        return (
          <button key={o.id} type="button" data-testid={`${testid}-${o.id}`}
            onClick={() => onChange(on ? value.filter((x) => x !== o.id) : [...value, o.id])}
            className={`inline-flex items-center gap-1 rounded-full border px-3 py-1.5 text-sm transition-colors ${on ? "bg-brand text-white border-brand" : "bg-white text-slate-600 border-slate-200 hover:border-brand/50"}`}>
            {o.name}
          </button>
        );
      })}
    </div>
  );
};
